<template>
  <div>
    <el-form
      :model="materialmanageForm"
      :size="$store.state.formSize"
      :rules="materialmanageFormRules"
      ref="refMaterialmanageForm"
      label-width="100px"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="物料类型：" prop="materialType">
            <el-select v-model="materialmanageForm.materialType" style="width:100%;" @change="materialTypeChange">
              <el-option
                v-for="item in materialTypeList"
                :key="item.label"
                :value="item.value"
                :label="item.label"
                >{{ item.label }}</el-option
              >
            </el-select>
          </el-form-item>
          <el-form-item label="物料名称：" prop="materialName">
            <el-input
              v-model="materialmanageForm.materialName"
              autocomplete="off"
              placeholder="请输入物料名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="供应商：" prop="merchantId">
            <el-select v-model="materialmanageForm.merchantId" style="width:100%;">
              <el-option
                v-for="item in merchantList"
                :key="item.label"
                :value="item.value"
                :label="item.label"
                placeholder="请选择供应商"
                >{{ item.label }}</el-option
              >
            </el-select>
          </el-form-item>
          <el-form-item label="物料规格：">
            <el-input
              v-model="materialmanageForm.specification"
              autocomplete="off"
              placeholder="请选择物料规格"
            ></el-input>
          </el-form-item>
          <el-form-item label="生产厂家：">
            <el-input
              v-model="materialmanageForm.manufacturer"
              autocomplete="off"
              placeholder="请输入生产厂家"
            ></el-input>
          </el-form-item>
          <el-form-item label="生产批次：">
            <el-input
              v-model="materialmanageForm.productionBatch"
              autocomplete="off"
              placeholder="请输入生产批次"
            ></el-input>
          </el-form-item>
          <el-form-item label="生产日期：">
            <el-date-picker
              v-model="materialmanageForm.productionDate"
              value-format="yyyy-MM-dd"
              autocomplete="off"
              type="date"
              style="width:100%"
              :placeholder="materialmanageForm.productionDate">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input
              v-model="materialmanageForm.remark"
              type="textarea"
              :rows="5"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="商品条码：" prop="barcode">
            <el-input
              v-model="materialmanageForm.barcode"
              autocomplete="off"
              placeholder="请输入商品条码"
            ></el-input>
          </el-form-item>
          <el-form-item label="物料商标：" prop="materialTrademark">
            <el-input
              v-model="materialmanageForm.materialTrademark"
              autocomplete="off"
              placeholder="请输入物料商标"
            ></el-input>
          </el-form-item>
          <el-form-item label="保质期：" prop="shelfLife">
            <el-input-number
              v-model="materialmanageForm.shelfLife"
              :min="1"
              :controls="false"
              placeholder="请输入保质期"
              style="width: 100px; vertical-align: middle;">
            </el-input-number>
            <el-select v-model="materialmanageForm.shelfLifeUnit" style="width: 88px; margin-left: 4px">
              <el-option label="天" value="天"></el-option>
              <el-option label="月" value="月"></el-option>
              <el-option label="年" value="年"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标准号：">
            <el-input
              v-model="materialmanageForm.standardNo"
              autocomplete="off"
              placeholder="请输入标准号"
            ></el-input>
          </el-form-item>
          <el-form-item label="产品图片：">
            <el-upload
              action="#"
              list-type="picture-card"
              :limit="parseInt('1')"
              :http-request="handleHttpRequest"
              :before-upload="beforeAvatarUpload"
              :on-change="uploadChange"
              :on-remove="uploadRemove"
              :class="{hide:hideUpload}"
              ref="upload"
              :file-list="initFile">
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{file}">
                  <img
                    class="el-upload-list__item-thumbnail" :src="materialmanageForm.imgUrl"
                  >
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                      v-if="!disabled"
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file)"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
            </el-upload>
            <Dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="">
            </Dialog>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- ===== 物料类型专属属性（基础字段固定显示，专属模块按类型联动渲染） ===== -->
      <!-- 农药 -->
      <template v-if="materialmanageForm.materialType === 2">
        <el-divider content-position="center">农药专属属性</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="农药登记证号：" prop="pesticideRegNo" label-width="180px">
              <el-input v-model="materialmanageForm.pesticideRegNo" autocomplete="off" placeholder="请输入农药登记证号"></el-input>
            </el-form-item>
            <el-form-item label="毒性：" label-width="180px">
              <el-select v-model="materialmanageForm.toxicity" style="width:100%;" placeholder="请选择毒性">
                <el-option label="低毒" value="低毒"></el-option>
                <el-option label="中毒" value="中毒"></el-option>
                <el-option label="高毒" value="高毒"></el-option>
                <el-option label="剧毒" value="剧毒"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="剂型：" label-width="180px">
              <el-input v-model="materialmanageForm.formulation" autocomplete="off" placeholder="请输入剂型"></el-input>
            </el-form-item>
            <el-form-item label="安全间隔期：" label-width="180px">
              <el-input v-model="materialmanageForm.safetyInterval" autocomplete="off" placeholder="请输入安全间隔期"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="农药生产许可证：" prop="pesticideProdLicense" label-width="180px">
              <el-input v-model="materialmanageForm.pesticideProdLicense" autocomplete="off" placeholder="请输入农药生产许可证"></el-input>
            </el-form-item>
            <el-form-item label="有效成分：" label-width="180px">
              <el-input v-model="materialmanageForm.activeIngredient" autocomplete="off" placeholder="请输入有效成分"></el-input>
            </el-form-item>
            <el-form-item label="防治对象：" label-width="180px">
              <el-input v-model="materialmanageForm.controlTarget" autocomplete="off" placeholder="请输入防治对象"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>

      <!-- 化肥 -->
      <template v-if="materialmanageForm.materialType === 3">
        <el-divider content-position="center">化肥专属属性</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="工业产品生产许可证号：" prop="industrialProdLicense" label-width="180px">
              <el-input v-model="materialmanageForm.industrialProdLicense" autocomplete="off" placeholder="请输入工业产品生产许可证号"></el-input>
            </el-form-item>
            <el-form-item label="养分配比：" label-width="180px">
              <el-input v-model="materialmanageForm.nutrientRatio" autocomplete="off" placeholder="请输入养分配比"></el-input>
            </el-form-item>
            <el-form-item label="总养分：" label-width="180px">
              <el-input v-model="materialmanageForm.totalNutrient" autocomplete="off" placeholder="请输入总养分"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="肥料类型：" label-width="180px">
              <el-input v-model="materialmanageForm.fertilizerType" autocomplete="off" placeholder="请输入肥料类型"></el-input>
            </el-form-item>
            <el-form-item label="氯离子含量：" label-width="180px">
              <el-input v-model="materialmanageForm.chlorideContent" autocomplete="off" placeholder="请输入氯离子含量"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>

      <!-- 种子 -->
      <template v-if="materialmanageForm.materialType === 1">
        <el-divider content-position="center">种子专属属性</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="种子生产经营许可证：" prop="seedProdLicense" label-width="180px">
              <el-input v-model="materialmanageForm.seedProdLicense" autocomplete="off" placeholder="请输入种子生产经营许可证"></el-input>
            </el-form-item>
            <el-form-item label="发芽率：" label-width="180px">
              <el-input v-model="materialmanageForm.germinationRate" autocomplete="off" placeholder="请输入发芽率"></el-input>
            </el-form-item>
            <el-form-item label="适宜区域：" label-width="180px">
              <el-input v-model="materialmanageForm.suitableRegion" autocomplete="off" placeholder="请输入适宜区域"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="品种审定编号：" prop="varietyApprovalNo" label-width="180px">
              <el-input v-model="materialmanageForm.varietyApprovalNo" autocomplete="off" placeholder="请输入品种审定编号"></el-input>
            </el-form-item>
            <el-form-item label="净度：" label-width="180px">
              <el-input v-model="materialmanageForm.purity" autocomplete="off" placeholder="请输入净度"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>

      <!-- 农膜 -->
      <template v-if="materialmanageForm.materialType === 4">
        <el-divider content-position="center">农膜专属属性</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="材质：" label-width="180px">
              <el-input v-model="materialmanageForm.materialTexture" autocomplete="off" placeholder="请输入材质"></el-input>
            </el-form-item>
            <el-form-item label="厚度：" label-width="180px">
              <el-input v-model="materialmanageForm.thickness" autocomplete="off" placeholder="请输入厚度"></el-input>
            </el-form-item>
            <el-form-item label="长宽：" label-width="180px">
              <el-input v-model="materialmanageForm.sizeDimensions" autocomplete="off" placeholder="请输入长宽"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="膜类型：" label-width="180px">
              <el-input v-model="materialmanageForm.filmType" autocomplete="off" placeholder="请输入膜类型"></el-input>
            </el-form-item>
            <el-form-item label="耐候期：" label-width="180px">
              <el-input v-model="materialmanageForm.weatheringPeriod" autocomplete="off" placeholder="请输入耐候期"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>

      <!-- 其他 -->
      <template v-if="materialmanageForm.materialType === 0">
        <el-divider content-position="center">其他专属属性</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="物料用途：" label-width="180px">
              <el-input v-model="materialmanageForm.materialUsage" autocomplete="off" placeholder="请输入物料用途"></el-input>
            </el-form-item>
            <el-form-item label="材质：" label-width="180px">
              <el-input v-model="materialmanageForm.materialTexture" autocomplete="off" placeholder="请输入材质"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="规格参数：" label-width="180px">
              <el-input v-model="materialmanageForm.specParams" autocomplete="off" placeholder="请输入规格参数"></el-input>
            </el-form-item>
            <el-form-item label="执行标准号：" label-width="180px">
              <el-input v-model="materialmanageForm.execStandardNo" autocomplete="off" placeholder="请输入执行标准号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </el-form>
    <div class="text-center">
      <el-button type="primary" :size="$store.state.buttonSize" :disabled="isDisabled" @click="debounceSubmit">确 定</el-button>
      <el-button :size="$store.state.buttonSize" @click="hanleResetFormVals"
        >取 消</el-button
      >
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { postWfsImg, wfsImgUrl } from '@/api/common'
import { debounce } from 'throttle-debounce'
import { getMaterialmanageDetail, putMaterialmanageAdd, postMaterialmanageEdit } from '@/api/materialmanage'
import { getTrackMerchant } from '@/api/merchant'

// 物料类型专属属性字段（农药/化肥/种子/农膜/其他）
const EXT_FIELDS = [
  'pesticideRegNo', 'pesticideProdLicense', 'toxicity', 'activeIngredient', 'formulation', 'controlTarget', 'safetyInterval',
  'industrialProdLicense', 'nutrientRatio', 'totalNutrient', 'fertilizerType', 'chlorideContent',
  'seedProdLicense', 'varietyApprovalNo', 'germinationRate', 'purity', 'suitableRegion',
  'materialTexture', 'thickness', 'sizeDimensions', 'filmType', 'weatheringPeriod',
  'materialUsage', 'specParams', 'execStandardNo'
]

const createForm = () => {
  const form = {
    // *条码
    barcode: '',
    // 产品图片地址
    img: '',
    imgUrl: '',
    // 生产厂家
    manufacturer: '',
    // *物料名称
    materialName: '',
    // *物料商标
    materialTrademark: '',
    // *物料类型 1:种子、2:农药、3:化肥、4:农膜、0:其它
    materialType: null,
    // *供应商选择
    merchantId: null,
    // 生产批次
    productionBatch: '',
    // 生产日期
    productionDate: '',
    // 备注
    remark: '',
    // *保质期（数值）
    shelfLife: null,
    // 保质期单位（天/个月/年）
    shelfLifeUnit: '个月',
    // 物料规格
    specification: '',
    // 标准号
    standardNo: ''
  }
  EXT_FIELDS.forEach(f => { form[f] = '' })
  return form
}

export default {
  data() {
    return {
      materialmanageForm: createForm(),
      isDisabled: false,
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      initFile: [],
      hideUpload: false,
      limitCount: 1,
      materialTypeList: [
        {
          value: 1,
          label: '种子'
        },
        {
          value: 2,
          label: '农药'
        },
        {
          value: 3,
          label: '化肥'
        },
        {
          value: 4,
          label: '农膜'
        },
        {
          value: 0,
          label: '其它'
        }
      ],
      merchantList: []
    }
  },
  computed: {
    // 校验规则：基础信息必填 + 按物料类型动态追加证件号必填
    materialmanageFormRules() {
      const rules = {
        materialName: [
          { required: true, message: '请输入物料名称', trigger: 'blur' }
        ],
        materialType: [
          { required: true, message: '请选择物料类型', trigger: 'blur' }
        ],
        shelfLife: [
          { required: true, message: '请输入保质期', trigger: 'blur' }
        ]
      }
      const t = this.materialmanageForm.materialType
      if (t === 2) { // 农药
        rules.pesticideRegNo = [{ required: true, message: '请输入农药登记证号', trigger: 'blur' }]
        rules.pesticideProdLicense = [{ required: true, message: '请输入农药生产许可证', trigger: 'blur' }]
      } else if (t === 3) { // 化肥
        rules.industrialProdLicense = [{ required: true, message: '请输入工业产品生产许可证号', trigger: 'blur' }]
      }
      // 种子/农膜/其他：证件号非必填
      return rules
    }
  },
  created() {
    this.debounceSubmit = debounce(300, this.materialmanageSubmit)
  },
  methods: {
    handleHttpRequest(option) {
      const formData = new FormData()
      if (option.data) {
        Object.keys(option.data).forEach(key => {
          formData.append(key, option.data[key])
        })
      }
      formData.append(option.filename, option.file)
      postWfsImg(formData).then(res => {
        if (res.status === 1) {
          this.materialmanageForm.img = res.data.filePath
          this.materialmanageForm.imgUrl = wfsImgUrl(res.data.filePath)
          this.initFile.push({ name: '1', url: wfsImgUrl(res.data.filePath) })
        } else {
          this.$message.error(res.msg || '图片上传失败')
        }
      }).catch(() => {
        this.$message.error('图片上传失败')
      })
    },
    uploadChange(file, fileList) {
      this.hideUpload = fileList.length >= this.limitCount
    },
    uploadRemove(file, fileList) {
      this.hideUpload = fileList.length >= this.limitCount
    },
    handleRemove(file) {
      this.materialmanageForm.img = ''
      this.materialmanageForm.imgUrl = ''
      this.initFile = []
      this.$refs.upload.handleRemove(file)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    hanleResetFormVals() {
      this.$set(this, 'materialmanageForm', createForm())
      this.$refs.refMaterialmanageForm.clearValidate()
      this.$emit('closePopup')
    },
    // 切换物料类型：渲染对应专属属性模块，并清空全部专属字段避免残留提交
    materialTypeChange() {
      EXT_FIELDS.forEach(f => { this.materialmanageForm[f] = '' })
      this.$nextTick(() => {
        if (this.$refs.refMaterialmanageForm) {
          this.$refs.refMaterialmanageForm.clearValidate(EXT_FIELDS)
        }
      })
    },
    materialmanageSubmit() {
      this.$refs.refMaterialmanageForm.validate(valid => {
        if (!valid) return false
        const materialmanageItems = this.currentID
          ? postMaterialmanageEdit
          : putMaterialmanageAdd
        const payload = {
          barcode: this.materialmanageForm.barcode,
          img: this.materialmanageForm.img,
          manufacturer: this.materialmanageForm.manufacturer,
          materialName: this.materialmanageForm.materialName,
          materialTrademark: this.materialmanageForm.materialTrademark,
          materialType: this.materialmanageForm.materialType,
          merchantId: this.materialmanageForm.merchantId,
          productionBatch: this.materialmanageForm.productionBatch,
          productionDate: this.materialmanageForm.productionDate,
          shelfLife: this.materialmanageForm.shelfLife,
          shelfLifeUnit: this.materialmanageForm.shelfLifeUnit,
          specification: this.materialmanageForm.specification,
          standardNo: this.materialmanageForm.standardNo,
          remark: this.materialmanageForm.remark,
          id: this.currentID || undefined
        }
        // 专属属性一并提交（切换类型时已清空非当前类型字段）
        EXT_FIELDS.forEach(f => { payload[f] = this.materialmanageForm[f] })
        materialmanageItems(payload).then(res => {
          if (res.status === 1) {
            this.currentID ? this.$message.success('编辑物料成功') : this.$message.success('新增物料成功')
            this.$emit('materialmanageFinish')
          } else {
            this.$message.error(res.msg)
            return false
          }
        })
      })
    },
    materialFormPopup(id) {
      this.initFile = []
      this.hideUpload = false
      const isAdd = !id
      this.$set(this, 'materialmanageForm', createForm())
      if (isAdd) {
        this.currentID = null
      } else {
        this.isDisabled = true
        getMaterialmanageDetail(id).then(res => {
          console.log(res)
          if (res.status === 1) {
            this.currentID = id
            this.materialmanageForm.barcode = res.data.barcode
            this.materialmanageForm.manufacturer = res.data.manufacturer
            this.materialmanageForm.materialName = res.data.materialName
            this.materialmanageForm.materialTrademark = res.data.materialTrademark
            this.materialmanageForm.materialType = res.data.materialType
            this.materialmanageForm.merchantId = res.data.merchantId
            this.materialmanageForm.productionBatch = res.data.productionBatch
            if (res.data.productionDate) {
              this.materialmanageForm.productionDate = moment(res.data.productionDate).format('YYYY-MM-DD')
            }
            this.materialmanageForm.shelfLife = res.data.shelfLife
            this.materialmanageForm.shelfLifeUnit = res.data.shelfLifeUnit || '个月'
            this.materialmanageForm.specification = res.data.specification
            this.materialmanageForm.standardNo = res.data.standardNo
            this.materialmanageForm.img = res.data.img
            this.materialmanageForm.remark = res.data.remark
            // 专属属性回显
            EXT_FIELDS.forEach(f => { this.materialmanageForm[f] = res.data[f] || '' })
            if (res.data.imgUrl) {
              this.materialmanageForm.imgUrl = res.data.imgUrl
              this.initFile.push({ name: '1', url: res.data.imgUrl })
              this.hideUpload = true
            } else {
              this.hideUpload = false
            }
            this.isDisabled = false
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 获取供应商列表
    getSupplierListData() {
      getTrackMerchant({
        type: 1,
        page: 1,
        size: 1000
      }).then(res => {
        if (res.status === 1) {
          const arr = []
          for (let i = 0; i < res.data.rows.length; i++) {
            arr.push({ label: res.data.rows[i].merchantName, value: res.data.rows[i].id })
          }
          this.merchantList = arr
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    beforeAvatarUpload(file) {
      const isType = /^image\/(jpeg|png|jpg|bmp)$/.test(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isType) {
        this.$message.error('请选择图片文件进行上传!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isType && isLt2M
    }
  },
  mounted() {
    this.getSupplierListData()
  },
  filters: {
    format(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    },
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD')
    }
  }
}
</script>
<style lang="scss">
.hide .el-upload--picture-card {
    display: none;
}
</style>
